import { ReportBlockTypeApiEnum } from '../../../../api/reports/enum/report-block-type-api.enum';
import { BlockModel } from '../../../../Common/PageBuilder/models/block.model';
import { ChartDisplayElementModel } from '../../../../Common/Reports/models/chart-display-element.model';


export function sharedReportDataFromTwoPointTwoToTwoPointThree(block: BlockModel, chartData: any): BlockModel {

    let data;
    const dataPoints = [];
    const displayElement = block.displayElement as ChartDisplayElementModel;

    if (block.type.key === ReportBlockTypeApiEnum.PROMINENCE_OVER_TIME) {
        data = displayElement.series[0].dataProvider.getValue();
        data.forEach(x => {
            dataPoints.push({
                id: x.id,
                label: x.label,
                mappingKeys: x.mappingKeys || {
                    date: x.xValue
                },
                value: x.yValue,
                percent: x.percent || x.yValue || 0,
                timeScale: x.timeScale,
                mentionCount: x.mentionCount,
                rawStartDate: x.rawDateFacetFrom,
                rawEndDate: x.rawDateFacetTo
            });
        });
        displayElement.series[0].dataProvider.next(dataPoints);
    }

    block['version'] = '2.3';
    return block;
}
